import { configStore } from "@/store/store";
import { VNodeDirective } from "vue";
import { getPermission } from "@/lib/permissions/utils";
import { DirectiveOptions } from "vue/types/options";

const PermissionDirective: DirectiveOptions = {
  bind(el: HTMLElement, binding: VNodeDirective) {
    const permission = getPermission(
      configStore.availablePermissions,
      binding.value
    );

    if (!configStore.permission || !permission) {
      return;
    }

    const passes = configStore.permission.level >= permission.level;

    if (!passes) {
      el.style.display = "none";
    }
  }
};

export default PermissionDirective;
